import { render, staticRenderFns } from "./setAliasModal.vue?vue&type=template&id=c1e324b0&scoped=true"
import script from "./setAliasModal.vue?vue&type=script&lang=js"
export * from "./setAliasModal.vue?vue&type=script&lang=js"
import style0 from "./setAliasModal.vue?vue&type=style&index=0&id=c1e324b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e324b0",
  null
  
)

export default component.exports